import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { JobComment } from "@/types";

/**
 * This hook is used to update a job comment in the job comments query
 * without refetching the entire query.
 */
export const useSetJobComment = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return ({ jobCommentToUpdate }: { jobCommentToUpdate: JobComment }) => {
    queryClient.setQueryData(
      ["job-comments", currentCompanyId, currentJobId],
      (cachedData: JobComment[]) => {
        return cachedData.map((jobComment) => {
          if (jobComment.id === jobCommentToUpdate.id) {
            return jobCommentToUpdate;
          }
          return jobComment;
        });
      },
    );
  };
};
